import { render } from "./editVideo.vue?vue&type=template&id=40c486a4"
import script from "./editVideo.vue?vue&type=script&lang=js"
export * from "./editVideo.vue?vue&type=script&lang=js"

import "./editVideo.vue?vue&type=style&index=0&id=40c486a4&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__